import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import Watch from "@/pages/Watch";
import SeriesPage from "@/pages/SeriesPage";
import Player from "@/pages/Player";
import Admin from "@/pages/Admin";
import { trackVisit } from "@/lib/analytics";

// Records a page view on every route change (whole site). Dynamic routes are
// normalized so "Most visited pages" stays meaningful. The admin dashboard is
// excluded so the owner's own visits don't inflate the numbers.
function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    const p = location.pathname || "/";
    if (p.startsWith("/admin")) return;
    let label = p;
    if (/^\/series\/[^/]+/.test(p)) label = "/series/:id";
    else if (/^\/watch\/[^/]+/.test(p)) label = "/watch/:id";
    trackVisit(label);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <VisitTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/watch" element={<Watch />} />
          <Route path="/series/:id" element={<SeriesPage />} />
          <Route path="/watch/:id" element={<Player />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
